import React from "react";
import { Box, Button, Modal, Typography } from "@mui/material";

import { useSetAssignment } from "../../globals/AssignmentContext";
import { createAssignmentAction } from "../../actions/createAssignment";
import { copyAssignmentAction } from "../../actions/copyAssignment";
import { addAssignmentAction } from "../../actions/addAssignment";
import AssignmentPicker from "./AssignmentPicker";
import { fetchAssignmentAction } from "../../actions/fetchAssignment";
import { useSetClass } from "../../globals/ClassContext";
import { useSetUser } from "../../globals/UserContext";
import dayjs from "dayjs";

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

export default function NewAssignmentModal(props) {
  const setAssignment = useSetAssignment();
  const setClass = useSetClass();
  const setUser = useSetUser();

  const forUser = (typeof props.forUser === "undefined") ? false : props.forUser 
  const user = props.user
  const classroom = props.classroom

  const [open, setOpen] = React.useState(false);
  const [copy, setCopy] = React.useState(true);

  const handleNewAssignment = async (event) => {
    const assignmentName = "New Assignment";

    const newAssignmentObject = {
      name: assignmentName,
      assigned_to: [],
      due_date: dayjs().add(2, 'day'),
      open_date: dayjs().add(1, 'day')
    }

    await createAssignmentAction(newAssignmentObject, user._id, setAssignment, setUser).then(async (createdAssignment) => {
      if (!forUser) {
        await addAssignmentAction(classroom?._id, createdAssignment?._id, setClass).then(() => {
          fetchAssignmentAction(createdAssignment?._id, setAssignment)
        });
      } else {
        fetchAssignmentAction(createdAssignment?._id, setAssignment)
      }
    })

    props.setPage("assignmentEditor");
  };

  const handleAddAssignment = (event) => {
    setCopy(false);
    setOpen(true);
  };

  const handleCopyAssignment = (event) => {
    setCopy(true);
    setOpen(true);
  };

  const handleAssignmentPicked = async (assignmentID) => {
    if (copy) {
      await copyAssignmentAction(assignmentID, user._id, setAssignment, setUser).then(async (assignmentCopy) => {
        if (!forUser) {
          await addAssignmentAction(classroom?._id, assignmentCopy?._id, setClass).then(() => {
            fetchAssignmentAction(assignmentCopy?._id, setAssignment)
          })
        } else {
          fetchAssignmentAction(assignmentCopy?._id, setAssignment)
        }
      })
    } else {
      await addAssignmentAction(classroom?._id, assignmentID, setClass).then(() => {
        fetchAssignmentAction(assignmentID, setAssignment)
      })
    }
    props.setPage("assignmentEditor");
  }

  const handleClose = () => {
    setOpen(false);
    props.handleClose();
  }

  return <Modal
        open={props.open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
    >
    <Box sx={modalStyle}>
      <Typography id="modal-modal-title" variant="h6" component="h2">
        {forUser ? "How would you like to add an assignment?" : "How would you like to create an assignment?"}
      </Typography>
      
      <Button sx={{marginTop:"15px", marginLeft:"5px"}} onClick={handleNewAssignment} variant="outlined" color="primary" size="medium">Create a new assignment</Button>
      {/*  If this modal is pulled up for a user outside of a class, do not show adding an assignment to class */}
      {!forUser ? <Button sx={{marginTop:"15px", marginLeft:"5px"}} onClick={handleAddAssignment} variant="outlined" color="primary" size="medium">Add an existing assignment</Button> : <></>}
      <Button sx={{marginTop:"15px", marginLeft:"5px"}} onClick={handleCopyAssignment} variant="outlined" color="primary" size="medium">Add a copy of an existing assignment</Button>
      <AssignmentPicker open={open} user={user} copy={copy} classroom={classroom} handleAssignmentPicked={handleAssignmentPicked} ></AssignmentPicker>
    </Box>
  </Modal>
}